import { fetchAuthSession } from 'aws-amplify/auth';
import { post, put, del } from 'aws-amplify/api';
import { useMutation, useQueryClient } from 'react-query';
import { MEDICATIONS_QUERY_KEY } from './useMedicationsQuery';

export const useMedicationsPostMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (formInputs) => {
      const session = await fetchAuthSession();
      const { body } = await post({
        apiName: 'pcmedapi',
        path: '/medications',
        options: {
          headers: {
            Authorization: session.tokens.idToken.toString(),
          },
          body: formInputs,
        },
      }).response;
      return await body.json();
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [MEDICATIONS_QUERY_KEY] });
    },
  });
};

export const useMedicationsPutMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (formInputs) => {
      const session = await fetchAuthSession();
      const { body } = await put({
        apiName: 'pcmedapi',
        path: '/medications',
        options: {
          headers: {
            Authorization: session.tokens.idToken.toString(),
          },
          body: formInputs,
        },
      }).response;
      return await body.json();
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [MEDICATIONS_QUERY_KEY] });
    },
  });
};

export const useMedicationsDeleteMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (id) => {
      const session = await fetchAuthSession();
      const { body } = await del({
        apiName: 'pcmedapi',
        path: '/medications',
        options: {
          headers: {
            Authorization: session.tokens.idToken.toString(),
          },
          queryParams: { id: id },
        },
      }).response;
      return await body.json();
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [MEDICATIONS_QUERY_KEY] });
    },
  });
};
